import React, { useState, useEffect } from "react";
import logger from "../utils/logger.ts";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  getPopular,
  highestSoldNFT,
  getRecentlyListed,
  getRecentlySold,
} from "../api/api";
import HeroSection from "components/HeroSection/HeroSection";
import Presale from "components/Presale/Presale";
import RecentStories from "components/stories/RecentStories";
import TradingCollectible from "components/TradingCollectible/TradingCollectible";
import HowItWork from "components/HowItWorks/HowItWorks";
import PresaleWorking from "components/Presale/PreSaleWorking";
import Gangstaverse from "components/Presale/Gangstaverse";
import GangstaBetListings from "components/GangstabetListings/GangstabetListings";
import Roadmap from "components/Roadmap/Roadmap";
import LeaderBoardPopularSkeleton from "components/Loader/LeaderBoardSkeleton/LeaderBoardPopularSkeleton";
import GangstaCard from "components/GangstaCard/GangstaCard";
import ArticleSection from "../components/Article/ArticleSection.component";
import { PROFILE } from "src/constants/routes";
import GangstaBetWorking from "components/HowThingsWork/HowThingsWork";
import {
  fetchLatestGangstersData,
  fetchLatestMintedGangstersData,
} from "../redux/actions/home";

import SEO from "components/SEO";

import Story from "components/Story/Story";

import { dummyData } from "../dummy/dummy.ts";

const Home = () => {
  const [redirect, setRedirect] = useState(false);
  const [dummy_data, setDummydata] = useState([]);
  const [recentlyListed, setRecentlyListed] = useState([]);
  const [loading, setLoading] = useState(false);
  const [highestSoldNfts, setHighestSoldNfts] = useState([]);
  const [recentlySoldNfts, setrecentlySoldNfts] = useState([]);

  const dispatch = useDispatch();

  const {
    isUpdatedGangstersLoading,
    updatedGangstersData,
    mintedGangstersData,
    isMintedGangstersLoading,
  } = useSelector((state) => state.home);

  useEffect(() => {
    dispatch(fetchLatestGangstersData(1));
    dispatch(fetchLatestMintedGangstersData(1));
    getDummyData();
    // getPopularTokens();
    // getHightestNfts();
    // getRecentlySoldNfts();
  }, []);

  function getDummyData() {
    setDummydata(dummyData.tokens);
  }

  // function getPopularTokens() {
  //   getRecentlyListed()
  //     .then((response) => {
  //       setRecentlyListed(response.data.recently_listed.tokens);
  //     })
  //     .catch((err) => {});
  // }

  // async function getHightestNfts() {
  //   try {
  //     setLoading(true);
  //     const res = await highestSoldNFT();
  //     setHighestSoldNfts(res.data.tokens.slice(0, 10));
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // }

  // async function getRecentlySoldNfts() {
  //   try {
  //     setLoading(true);
  //     const res = await getRecentlySold();
  //     logger.debug("API response received", { response: res });

  //     if (res.data && res.data.recently_sold && res.data.recently_sold.tokens) {
  //       setrecentlySoldNfts(res.data.recently_sold.tokens.slice(0, 10));
  //       logger.debug("Recently sold NFTs set", { count: res.data.recently_sold.tokens.length });
  //     } else {
  //       logger.warn("No recently sold data in response", { data: res.data });
  //       setrecentlySoldNfts([]);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     logger.error("Error fetching recently sold NFTs", { error });
  //     setrecentlySoldNfts([]);
  //     setLoading(false);
  //   }
  // }

  if (redirect) {
    return <Navigate to={PROFILE.INDEX} />;
  }
  // console.log(highestSoldNfts);
  const pageMetaData = {
    pageTitle: `GangstaBet: A Digital Collectible  `,
    pageDescription: null,
    pageKeywords: null,
    pageImage: null,
  };
  return (
    <SEO pageMetaData={pageMetaData}>
      {/* <CountdownTimer /> */}
      <HeroSection />
      <Story />
      {/* <RecentStories /> */}
      {/* <RecentStories /> */}
      {/* {import.meta.env.VITE_BASE_URL == "http://localhost:3006/api" ? ( */}
      <Presale />
      {/* ) : null} */}
      {/* <ArticleSection /> */}

      {/* <Presale /> */}

      <HowItWork isLoading={loading} />
      {/* <GangstaBetListings
        GangsterObject={{
          recentlyListed: recentlyListed,
          recentlySoldNfts: recentlySoldNfts,
          highestSoldNfts: highestSoldNfts,
          loading: loading,
        }}
      /> */}

      <TradingCollectible isLoading={isUpdatedGangstersLoading} />

      <>
        {recentlyListed.length > 0 && !isUpdatedGangstersLoading ? (
          <div className="how-it-works container">
            <div className="container">
              {recentlyListed.length > 0 ? (
                <div>
                  <p className="sample-art">Recently Listed </p>
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          ""
        )}
      </>

      <GangstaBetWorking />
      <PresaleWorking />
      {/* <Gangstaverse /> */}
      {/* <Roadmap /> */}

      {/* <ChangableProperties /> */}
      {/* <BuyTheGangsta setArtWork={() => setRedirect(true)} /> */}
    </SEO>
  );
};

export default Home;
